import { UseWebPageProps, WebPage } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request'
import { Keys, ReadHook, useStateManager } from 'state-manager'

export const useGetApplicationsWebPage: ReadHook<WebPage, UseWebPageProps> = (opts) => {
  const sm = useStateManager()

  const { data, ...rest } = sm.use(
    Keys.BankApplication.ListByCriteria({
      status: opts?.status,
      sortAsc: opts?.sortAsc,
      page: opts?.page,
      size: opts?.size,
      searchQuery: opts?.searchQuery,
      createdById: opts?.createdById,
      currentOwnerId: opts?.currentOwnerId
    }),
    () =>
      Request.post(Request.urls.bank.applicationListWebpages, {
        status: opts?.status,
        sortAsc: opts?.sortAsc,
        page: opts?.page,
        size: opts?.size,
        searchQuery: opts?.searchQuery,
        createdById: opts?.createdById,
        currentOwnerId: opts?.currentOwnerId
      }),
    { keepPreviousData: true }
  )

  return {
    ...rest,
    data
  }
}
